import React, {useState, memo, FunctionComponent, useEffect, useRef} from 'react';
import './CategoryList.less';

import {EntryList} from 'compositions/entry-list/EntryList.tsx';
import {Block} from 'compositions/block/Block.tsx';
import {Card} from 'elements/card/Card.tsx';
import {Category} from 'helpers/menu.helper.types';
import {MenuEntryModifierSelections, ModifierGroup} from 'helpers/modifier.helper.types';
import {ScrollAnchor} from '../../elements/scroll-anchor/ScrollAnchor';

interface CategoryListProps {
	categories: Array<Category>,
	allModifierGroups: Array<ModifierGroup>,
	menuModifierSelections: { [key: number]: MenuEntryModifierSelections },
	isNotPossibleToOrder: boolean,
	selectedCategoryIdClick: { id: number, click: boolean },
	onAddClick: () => void,
	onModifierGroupClick: () => void,
	onVisible?: (isVisible: boolean, categoryId) => void,
	expandedEntryId?: number,
	onEntryClick: () => void,
	onAllergensClick: (allergens: string, e: any, entryId: number) => void,
	entryQuantities: any[];
	onEntryQuantityChange: (entryId, quantity) => void;
	cartNotEmpty?: boolean;
}

export const CategoryList: FunctionComponent<CategoryListProps> = memo((
	{
		categories = [],
		allModifierGroups,
		menuModifierSelections,
		selectedCategoryIdClick,
		isNotPossibleToOrder,
		onAddClick,
		onModifierGroupClick,
		onVisible,
		expandedEntryId,
		onEntryClick,
		onAllergensClick,
		entryQuantities,
		onEntryQuantityChange,
		cartNotEmpty,
	}
) => {
	return (
		<ul className="category-list">
			{categories
				.filter(category => category.entries.length > 0)
				.map((category) => {
					return (
						<React.Fragment key={category.id}>
							<ScrollAnchor
								id={'cat-' + category.id}
								selectedItemId={'cat-' + selectedCategoryIdClick.id}
								onVisible={onVisible ? (isVisible => onVisible(isVisible, category.id)) : null}
								hasClick={selectedCategoryIdClick.click}
							/>
							<li
								className={`category-list__item`}
								key={category.id}
							>
								<Block title={category.name} isShowTitle={categories.length > 1}>
									<Card isNoPaddings>
										<EntryList
											entries={category.entries}
											allModifierGroups={allModifierGroups}
											menuModifierSelections={menuModifierSelections}
											onEntryClick={onEntryClick}
											onAddClick={onAddClick}
											onModifierGroupClick={onModifierGroupClick}
											expandedEntryId={expandedEntryId}
											isNotPossibleToOrder={isNotPossibleToOrder}
											onAllergensClick={onAllergensClick}
											entryQuantities={entryQuantities}
											onEntryQuantityChange={onEntryQuantityChange}
											cartNotEmpty={cartNotEmpty}
										/>
									</Card>
								</Block>
							</li>
						</React.Fragment>
					);
				})}
		</ul>
	);
});
